import { CountryID } from "@al/base-lib";

/**
 * 货币ISO 代码，参考 https://zh.wikipedia.org/wiki/ISO_4217
 */
export const isoCurrencyConfig: Partial<Record<CountryID, "EUR" | "PLN">> = {
  [CountryID.DE]: "EUR",
  [CountryID.BE]: "EUR",
  [CountryID.ES]: "EUR",
  [CountryID.PL]: "PLN",
  [CountryID.FR]: "EUR",
  [CountryID.IT]: "EUR",
};
